(function () {

  function initTjrReviewSlider(sectionContainer) {

    const sliders = sectionContainer.querySelectorAll(".tjr-reviews-swiper");

    sliders.forEach((slider) => {

      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      const section = slider.closest(".tjr-reviews-section");

      if (!section) return;

      const prevBtn = section.querySelector(".tjr-review-prev");
      const nextBtn = section.querySelector(".tjr-review-next");

      const desktopArrows =
        slider.dataset.desktopArrows === "true";

      const mobileArrows =
        slider.dataset.mobileArrows === "true";

      const isMobile = window.matchMedia("(max-width: 749px)").matches;

      if (prevBtn && nextBtn) {

        if (isMobile) {

          if (!mobileArrows) {
            prevBtn.style.display = "none";
            nextBtn.style.display = "none";
          } else {
            prevBtn.style.display = "";
            nextBtn.style.display = "";
          }

        } else {

          if (!desktopArrows) {
            prevBtn.style.display = "none";
            nextBtn.style.display = "none";
          } else {
            prevBtn.style.display = "";
            nextBtn.style.display = "";
          }

        }
      }

      new Swiper(slider, {

        loop: true,

        speed: 500,

        grabCursor: false,

        watchOverflow: true,

        observer: true,

        observeParents: true,

        observeSlideChildren: true,

        centeredSlides: true,

        allowTouchMove: false,

        simulateTouch: false,

        touchRatio: 0,

        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        },

        breakpoints: {

          0: {
            slidesPerView: 1.08,
            centeredSlides: true,
            spaceBetween: 16,

            allowTouchMove: false,
            simulateTouch: false,
            touchRatio: 0
          },

          750: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 24,

            allowTouchMove: true,
            simulateTouch: true,
            touchRatio: 1
          },

          990: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 24,

            allowTouchMove: true,
            simulateTouch: true,
            touchRatio: 1
          }

        }

      });

    });

  }

  document.addEventListener("DOMContentLoaded", function () {
    initTjrReviewSlider(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initTjrReviewSlider(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {

    const slide = event.target.closest(".swiper-slide");

    if (!slide) return;

    const swiperEl = slide.closest(".tjr-reviews-swiper");

    if (!swiperEl || !swiperEl.swiper) return;

    swiperEl.swiper.slideTo(
      slide.dataset.swiperSlideIndex || slide.swiperSlideIndex,
      300
    );

  });

})();